export default __webpack_public_path__ + "bc115568a11cee33d543cbbacb9938c4.jpg";